var setSiteCookies;

setSiteCookies = require('./setSiteCookies');

Groupon.setWindowLocation = require('./setWindowLocation');

module.exports = Groupon.Utils.changeUserLanguage = function(language) {
  var alternate, href, hreflang;
  setSiteCookies({
    user_locale: null
  });
  setSiteCookies({
    user_locale: language
  });
  hreflang = "[hreflang='" + language.replace('_', '-') + "']";
  if ((alternate = $("head link" + hreflang).attr("href"))) {
    href = alternate;
  } else {
    href = '/';
  }
  return Groupon.setWindowLocation(href);
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL2NoYW5nZVVzZXJMYW5ndWFnZS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvc2tpbS9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvY2hhbmdlVXNlckxhbmd1YWdlLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLGNBQUEsR0FBaUIsT0FBQSxDQUFRLGtCQUFSOztBQUNqQixPQUFPLENBQUMsaUJBQVIsR0FBNEIsT0FBQSxDQUFRLHFCQUFSOztBQUU1QixNQUFNLENBQUMsT0FBUCxHQUFpQixPQUFPLENBQUMsS0FBSyxDQUFDLGtCQUFkLEdBQW1DLFNBQUMsUUFBRDtBQUNsRCxNQUFBO0VBQUEsY0FBQSxDQUFlO0lBQUEsV0FBQSxFQUFhLElBQWI7R0FBZjtFQUNBLGNBQUEsQ0FBZTtJQUFBLFdBQUEsRUFBYSxRQUFiO0dBQWY7RUFDQSxRQUFBLEdBQVcsYUFBQSxHQUFnQixRQUFRLENBQUMsT0FBVCxDQUFpQixHQUFqQixFQUFzQixHQUF0QixDQUFoQixHQUE2QztFQUV4RCxJQUFHLENBQUMsU0FBQSxHQUFZLENBQUEsQ0FBRSxXQUFBLEdBQWMsUUFBaEIsQ0FBeUIsQ0FBQyxJQUExQixDQUErQixNQUEvQixDQUFiLENBQUg7SUFDRSxJQUFBLEdBQU8sVUFEVDtHQUFBLE1BQUE7SUFHRSxJQUFBLEdBQU8sSUFIVDs7U0FLQSxPQUFPLENBQUMsaUJBQVIsQ0FBMEIsSUFBMUI7QUFWa0QifQ==
